import * as React from "react";
import { exception } from "react-ga";

interface ErrorBoundaryProps {
  component: React.ComponentType<{}>;
  children: any;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  public state: ErrorBoundaryState = {
    hasError: false,
  };

  public componentDidCatch(error, info) {
    this.setState(state => ({ ...state, hasError: true }));

    // Track any runtime errors
    exception({
      description: error,
      fatal: true,
    });
  }

  public render() {
    const { component: ErrorView } = this.props;
    return this.state.hasError ? <ErrorView /> : this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.tsx